export default __webpack_public_path__ + "static/MyriadPro-Semibold-9aebfb47f879be4aff2306f3aba10dc1.woff2";